import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Format price in Philippine Peso format
export function formatPrice(price: number | null | undefined): string {
  if (!price) return '₱0'

  if (price >= 1000000) {
    const millions = price / 1000000
    return `₱${millions.toFixed(millions % 1 === 0 ? 0 : 1)}M`
  }

  if (price >= 1000) {
    const thousands = price / 1000
    return `₱${thousands.toFixed(thousands % 1 === 0 ? 0 : 0)}K`
  }

  return `₱${price.toLocaleString('en-US')}`
}

// Format price with full number
export function formatPriceFull(price: number | null | undefined): string {
  if (!price) return '₱0'
  return `₱${price.toLocaleString('en-US')}`
}
